var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { eager: "", "max-width": "330" },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "primary white--text" },
            [
              _vm._v("Link per pagamento\n      "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { depressed: "", icon: "" },
                  on: {
                    click: function ($event) {
                      return _vm.dismiss()
                    },
                  },
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("v-divider"),
          _vm._v(" "),
          _c("div", { staticClass: "px-5 pt-5" }, [
            _c("div", { staticClass: "cc d-flex justify-center mt-2" }, [
              _c("img", {
                attrs: { src: _vm.firebase_host + "/static/img/cc-1.png" },
              }),
              _vm._v(" "),
              _c("img", {
                attrs: { src: _vm.firebase_host + "/static/img/cc-2.png" },
              }),
              _vm._v(" "),
              _c("img", {
                attrs: { src: _vm.firebase_host + "/static/img/cc-3.png" },
              }),
              _vm._v(" "),
              _c("img", {
                attrs: { src: _vm.firebase_host + "/static/img/cc-4.png" },
              }),
            ]),
            _vm._v(" "),
            _c("b", [_vm._v("Soluzione A)")]),
            _vm._v(
              " Hai una carta di credito? Puoi cliccare su Paypal e\n      poi, invece di effettuare il login Paypal, cliccare su\n      "
            ),
            _c("b", [_vm._v("Paga con una carta")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "cc d-flex justify-center mt-2" },
              [_c("v-icon", [_vm._v("link")])],
              1
            ),
            _vm._v(" "),
            _c("b", [_vm._v("Soluzione B) ")]),
            _vm._v(" Asta Live può essere "),
            _c("b", [_vm._v("sbloccata da chiunque")]),
            _vm._v(
              ".\n      Copia il link qui sotto e invialo a un amico/familiare disposto a\n      sbloccare la tua asta\n    "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "px-5 pb-5" }, [
            _c("div", { staticClass: "link-to-copy" }, [
              _vm._v(_vm._s(_vm.url)),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "px-5 pb-5 text-center" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "orange white--text",
                  attrs: { depressed: "", rounded: "" },
                  on: { click: _vm.copyToClipboard },
                },
                [_vm._v("\n        COPIA LINK\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }